import { getApiRequestFromSearchQuery } from 'utils/searchQuery';
import { searchProductsByCustomAisle } from 'redux/modules/search/actions/fetch-custom-aisle-products';

const categoryAisleFetcher =
  ({ location: { search: query, state }, match }, rootCategory) =>
  dispatch => {
    const { params: { '*': aisleRef } = {} } = match;

    if (!(aisleRef && rootCategory)) {
      return Promise.resolve();
    }

    const { filterTags = [], sortBy = 'COLLECTION_ORDER' } =
      getApiRequestFromSearchQuery(query) || {};

    const params = {
      aisleRef,
      filterTags,
      rootCategory,
      sortBy,
    };

    return dispatch(
      searchProductsByCustomAisle({
        params,
        refinement: !!state?.refinement,
      }),
    );
  };

export const createAisleFetcher = rootCategory => props =>
  categoryAisleFetcher(props, rootCategory);
